<div class="icon-wrapper">
  <img alt="" src="assets/design-modern/other/tr-small-logo.png" />
</div>
